import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useI18nTranslation } from 'platform-i18n-utils';

import { I18N_KEYS, LOADING_ARIA_LABEL, LOADING_FORM_MESSAGE } from '../../constants';

const TicketPageLoading = ({ message }) => {
  const { t } = useI18nTranslation();

  return (
  <Box
    data-testid="ticket-page-loading"
    sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2
    }}
  >
    <CircularProgress size={40} aria-label={t(I18N_KEYS.LOADING_ARIA_LABEL, { defaultValue: LOADING_ARIA_LABEL })} />
    <Typography variant="body1" color="text.secondary" role="status" aria-live="polite">
      {message ?? t(I18N_KEYS.LOADING_FORM, { defaultValue: LOADING_FORM_MESSAGE })}
    </Typography>
  </Box>
  );
};

TicketPageLoading.propTypes = {
  message: PropTypes.string
};

export default TicketPageLoading;
